const constant={
    WOMEN_COLLECTION:'Women Collection',
    MEN_COLLECTION:'Men Collection',
}
export default constant;